import {Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Typography} from "@mui/material";
import {LoadingButton} from "@mui/lab";
import React, {useState} from "react";
import {deleteRole} from "../../api/role";
import {Role} from "../../types/Role";

type DeleteRoleDialogProps = {
    onClose?: () => void,
    target?: Role,
    open?: boolean,
    onEntityActionStatusChange?: (state?: "success" | "error", message?: string) => void,
}

const DeleteRoleDialog = (props: DeleteRoleDialogProps) => {
    const [deleting, setDeleting] = useState(false)

    const handlePostDeleteSuccess = () => {
        setDeleting(false)
        props.onEntityActionStatusChange("success", "Role deleted successfully")
        props.onClose()
    }
    const handlePostDeleteFailure = (reason) => {
        setDeleting(false)
        props.onEntityActionStatusChange("error", reason)
        props.onClose()
    }

    const handleDelete = () => {
        setDeleting(true)
        deleteRole(props.target.id)
            .then(handlePostDeleteSuccess)
            .catch(handlePostDeleteFailure)
    }

    return <Dialog
        maxWidth={"md"}
        open={props.open}
        onClose={props.onClose}>
        <DialogTitle sx={{fontSize: "large"}}>Supprimer un rôle</DialogTitle>

        <DialogContent sx={{py: 3}}>
            <Typography variant={"body1"}>
                Le rôle '{props.target?.name}' sera supprimé de façon définitive, cette action est irréversible. Poursuivre?
            </Typography>
        </DialogContent>

        <Divider/>

        <DialogActions>
            <Button variant={"outlined"} onClick={props.onClose}>Annuler</Button>
            <LoadingButton variant="contained" color={"error"}
                           sx={{color: "white"}}
                           loading={deleting}
                           onClick={handleDelete}>
                Oui, supprimer
            </LoadingButton>
        </DialogActions>
    </Dialog>

}

export default DeleteRoleDialog